import { render, staticRenderFns } from "./_Account.vue?vue&type=template&id=2a4b88a9&scoped=true&"
import script from "./_Account.vue?vue&type=script&lang=js&"
export * from "./_Account.vue?vue&type=script&lang=js&"
import style0 from "./_Account.vue?vue&type=style&index=0&id=2a4b88a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b88a9",
  null
  
)

export default component.exports